export default __webpack_public_path__ + "static/media/07.487b9dd5.jpg";